import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

export const StDocumentLink = styled.div<{
  selected?: boolean
}>`
  display: flex;
  padding-bottom: ${({ theme }) => theme.UI.Spacing.Space6}px;
  position: relative;
  border-left: 3px solid transparent;
  border-bottom: 2px solid ${({ theme }) => theme.Colors.Neutrals.Lighter};

  background-color: ${({ theme }) => theme.Colors.Background.White};
  transition:
    background-color 120ms ease-out,
    box-shadow 120ms ease-out,
    border-left-color 120ms ease-out;

  ${({ theme, selected }) =>
    selected
      ? `
        background-color: ${theme.Colors.Background.Light};
        border-left-color: ${theme.Colors.Theme.Primary};
        box-shadow: inset 0 0 0 1px ${theme.Colors.Neutrals.Light};
      `
      : ''}

  padding: ${({ theme }) => theme.UI.SpacingPx.Space4}
    ${({ theme }) => theme.UI.SpacingPx.Space6};

  @media ${breakpoints.m} {
    border-bottom: none;
  }

  &:last-child {
    border-bottom: none;
  }

  @media ${breakpoints.l} {
    padding: ${({ theme }) => theme.UI.SpacingPx.Space4}
      ${({ theme }) => theme.UI.SpacingPx.Space10};
  }

  flex-direction: column;
  justify-content: flex-start;
  cursor: pointer;
`

export const StDocumentIconWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  border: 2px solid ${({ theme }) => theme.Colors.Neutrals.Lighter};
  background: white;
  flex-shrink: 0;
`

export const StStatusIndicator = styled.div<{ signed: boolean }>`
  position: absolute;
  right: -12px;
  top: -6px;
  background-color: ${({ signed }) => (signed ? '#DFF6E4' : '#FFF7EC')};

  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
  border-radius: 50%;
`

export const StDocumentContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const StDocumentName = styled.div`
  display: flex;
  font-weight: 700;
  width: 100%;
  padding-bottom: ${({ theme }) => theme.UI.Spacing.Space2}px;
  text-align: left;
  width: 100%;
  word-break: break-word;

  @media ${breakpoints.s} {
    padding-bottom: 0;
  }
`
export const StDocumentDate = styled.div`
  display: flex;
  align-items: center;
`

export const StDocumentDetails = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: left;
  flex-direction: row;
  align-items: center;
  width: 100%;
`

export const StDotContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 20px;
  flex-shrink: 0;
`

export const StDot = styled.div`
  ${({ color }) => `
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${color};
  `}
`
